import { useEffect } from 'react';

export const useEffectOnMounted = cb => {
	useEffect(cb, []);
};
